import { render, staticRenderFns } from "./PensumsView.vue?vue&type=template&id=0da4261d"
import script from "./PensumsView.vue?vue&type=script&lang=js"
export * from "./PensumsView.vue?vue&type=script&lang=js"
import style0 from "./PensumsView.vue?vue&type=style&index=0&id=0da4261d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports